export { default as UsersSolidIcon } from './UsersSolidIcon';
